import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Link } from '@comparethemarketau/manor-link';

import { ProductTermsModal } from './product_terms_modal';
import { withQuoteFlatten } from './with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    discountOfferTermsLinkContainer: {

    },
    modalContent: {
        fontSize: theme.fontSize.base,
        lineHeight: theme.lineHeight.normal,
        fontWeight: theme.fontWeight.normal,
        textAlign: 'left',
        marginBottom: '2.8rem',
        marginTop: '2.4rem'
    }
}));

const _DiscountOfferTermsLink = (props) => {
    const { productDiscountOfferTerms, providerCode, productUnderwriterName, productName, productId, children } = props;

    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const [modalVisible, setModalVisible] = useState(false);

    const handleClickOpenModal = (e) => {
        e.preventDefault();
        setModalVisible(true);
    };

    const handleClose = () => {
        setModalVisible(false);
    };

    return (
        productDiscountOfferTerms ? (
            <>
                <Link
                    trackingLabel={`Discount offer terms link for product ${productId}`}
                    handleClick={handleClickOpenModal}
                    underline={'none'}
                >
                    {children}
                </Link>
                <ProductTermsModal
                    handleClose={handleClose}
                    visible={modalVisible}
                    title="More Information"
                    providerCode={providerCode}
                    productName={productName}
                    productUnderwriterName={productUnderwriterName}
                    dynamicHeight={false}
                >
                    <div className={classes.modalContent} dangerouslySetInnerHTML={{ __html: productDiscountOfferTerms }} />
                </ProductTermsModal>
            </>
        ) : null
    );
};

_DiscountOfferTermsLink.propTypes = {
    children: PropTypes.node,

    quote: PropTypes.object,
    productId: PropTypes.string,
    providerCode: PropTypes.string,
    productUnderwriterName: PropTypes.string,
    productName: PropTypes.string,
    productDiscountOfferTerms: PropTypes.string
};

const DiscountOfferTermsLink = withQuoteFlatten(_DiscountOfferTermsLink);

export { DiscountOfferTermsLink };
